import * as mutationTypes from './types/mutation_types';

import initialState from './initialState';

export default {
  [mutationTypes.CATEGORIES_REQUEST](state) {
    Object.assign(state, { loading: true, error: null });
  },
  [mutationTypes.CATEGORIES_SUCCESS](state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },
  [mutationTypes.CATEGORIES_ERROR](state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      error: payload || true,
    });
  },
  [mutationTypes.CATEGORIES_RESET](state) {
    Object.assign(state, ...initialState);
  },
  [mutationTypes.CATEGORIES_SELECT](state, payload) {
    Object.assign(state, { selected: payload });
  },
  [mutationTypes.CATEGORIES_SELECT_RESET](state) {
    Object.assign(state, { selected: { title: '' } });
  },
};
